import React, { FC } from 'react';
import { Button } from '@src/components/Button';
import { SwitchCompanyModalProps } from './props';
import './styles.scss';

export const SwitchCompanyModal: FC<SwitchCompanyModalProps> = ({ activeCompanyId, activeCompanyName }) => {
  return (
    <div className="switch-modal">
      <h3 className="switch-modal__title">You have been logged into {activeCompanyName}.</h3>

      <Button className="switch-modal__continue-button" href={`/employer/switch-company/${activeCompanyId}`}>
        Continue
      </Button>
    </div>
  );
};
